import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tt-h4",
  "use": "icon-tt-h4-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol viewBox=\"0 0 26 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tt-h4\">\n<path d=\"M14.8967 20V4H12.4139V10H7.44834V4H4.96558V20H7.44834V13H12.4139V20H14.8967Z\" fill=\"CurrentColor\" />\n<path d=\"M25.5679 15.2188V17.2051H16.3482L16.2251 15.667L21.5601 7.20312H23.5728L21.3931 10.8506L18.7388 15.2188H25.5679ZM24.1177 7.20312V20H21.5864V7.20312H24.1177Z\" fill=\"CurrentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol